import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types'; 

export async function fetchMatrixChildren(app, params) {
  const { id } = params;
  const dataParams = { 
    list_type: 'item',
    filters: { parent: { _id: id } }
  };
  return common.getListData(app, dataParams);
}

export function fetchMatrixDetailForEdit(app, params) {
  const { id } = params;
  return common.getDoc(app, { id, docType: DocType.ITEM });
}

export function fetchDefaultItemLocation(app, params) {
  const { id } = params;
  const service = common.getAccountService(app, DocType.ITEM_LOCATION);
  const options = {
    "selector": {
      "doc_type": DocType.ITEM_LOCATION,
      "default": true,
      "item._id": id
    },
    limit: 10000,
    // profile: app.get('user_info')
  };
  return service.find({ query: options });
}

export function fetchMatrixDefaultItemLoc(app, params) {
  const { matrixItemIds } = params;
  const service = common.getAccountService(app, DocType.ITEM_LOCATION);
  const options = {
    "selector": {
      "doc_type": DocType.ITEM_LOCATION,
      "default": true,
      "item._id": {
        "$in": matrixItemIds
      }
    },
    limit: 10000,
    // profile: app.get('user_info')
  };
  return service.find({ query: options });
}

export function getPriceBook(app, params) {
  const { id } = params;
  return common.getDoc(app, { id, docType: 'price_book' });
}

export function getMatrixAttribute(app, params) {
  const { id } = params;
  return common.getDoc(app, { id, docType: 'attribute_value' }); // TODO: check if correct doctype
}

export function getParentItem(app, params) {
  const { id } = params;
  return common.getDoc(app, { id, docType: DocType.ITEM });
}


export function generateMatrixItem(app, data) {
  const service = common.getAccountService(app, 'item-matrix/generate');
  return service.create(data, {}, false, { timeout: 0 });
}

export function getMatrixItem(app, params) {
  return common.queryDocs(app, 'item-matrix/generate', params);
}

